import { Component, OnInit } from "@angular/core";
import { Data, Router, NavigationEnd, ActivatedRoute } from "@angular/router";
import { filter } from "rxjs/operators";
import { Breadcrumb } from "./breadcrumb.model";
import { HomeService } from 'src/app/service/home.service';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {
  public breadcrumbs: Breadcrumb[];

  constructor(private router: Router, private activatedRoute: ActivatedRoute, private homeService: HomeService) {
    this.breadcrumbs = this.buildBreadcrumbs(this.activatedRoute.root);
  }

  ngOnInit() {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.breadcrumbs = this.buildBreadcrumbs(this.activatedRoute.root);
        this.breadcrumbs = this.breadcrumbs.filter((thing, i, arr) => arr.findIndex(t => t.label === thing.label) === i);
      });
  }

  private buildBreadcrumbs(
    activatedRoute: ActivatedRoute,
    url: string = ""
  ): Breadcrumb[] {
    const children: ActivatedRoute[] = activatedRoute.children;

    if (children.length === 0) {
      return [];
    }

    let breadcrumbs: Breadcrumb[] = [];

    for (const child of children) {
      const routeURL: string = child.snapshot.url
        .map(segment => segment.path)
        .join(`/`);

      if (routeURL !== "") {
        url += `/${routeURL}`;
      }

      const routeData: Data = child.snapshot.data;

      if (routeData["breadcrumb"]) {
        breadcrumbs.push({ label: routeData["breadcrumb"], url: url, navigate: routeData["navigate"] != undefined ? routeData["navigate"] : true });
      } else if (routeData["apiData"] && routeData["apiData"].breadcrumb) {
        breadcrumbs.push({
          label: routeData["apiData"].breadcrumb,
          url: url,
          navigate: routeData["navigate"] != undefined ? routeData["navigate"] : true
        });
      }

      breadcrumbs = breadcrumbs.concat(this.buildBreadcrumbs(child, url));
    }

    return breadcrumbs;
  }

  naviagte(url:any) {
    // localStorage.setItem('currentIndex', '0')
    // this.homeService.updateMenuHighlight.emit('/home');
    // this.router.navigate([url])
  }
}
